import './AboutPage.css'

import React from 'react'
import Markdown from 'react-markdown'
import { withProps } from 'recompose'

import { getAboutContent, getFeedbackCfg } from '../app/selectors'
import content from '../content'
import Feedback from '../addons/feedback/Feedback'

const AboutPage = ({ text, gallery, feedbackCfg }) => (
  <div>
    <Markdown source={text} />
    <Feedback cfg={feedbackCfg} />
    <div className="AboutPage-gallery">
      {gallery.map(img => (
        <img
          src={img.src}
          alt={img.title}
          key={img.src}
          className="AboutPage-galleryItem"
        />
      ))}
    </div>
  </div>
)

const aboutContent = getAboutContent(content)
const feedbackCfg = getFeedbackCfg(content)

const withPageContent = withProps({
  text: aboutContent.text,
  gallery: aboutContent.gallery,
  feedbackCfg,
})

export default withPageContent(AboutPage)



// WEBPACK FOOTER //
// ./src/containers/AboutPage.js